import { render } from "./collection-carousels.vue?vue&type=template&id=44546656"
import script from "./collection-carousels.vue?vue&type=script&lang=js"
export * from "./collection-carousels.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-packs/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__